import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ComboBoxComponent } from './combobox.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    ComboBoxComponent
  ],
  declarations: [
    ComboBoxComponent
  ],
})
export class ComboBoxModule { }
